export default __webpack_public_path__ + "static/media/lock.15cb2fa7.svg";